import React from 'react';
import styled from '@emotion/styled';
import theme from '../design-system/theme';
import {modularScale} from "../design-system/utils";

export default class SiteDownloadButtons extends React.PureComponent {

    render() {
        const {textResources, isIos, color} = this.props;

        return (
            <StyledBox>
                <div className="button-container">
                    <a href={isIos ? textResources["download_ios_link"] : textResources["download_direct_link"]}
                       target="_blank"
                       rel="noopener noreferrer"
                       onClick={() => window._paq.push(['trackEvent', 'Download', 'App', (isIos ? textResources["download_ios_tracking_name"] : textResources["download_direct_tracking_name"])])}
                    >
                        <StyledDownloadButton style={{backgroundColor: color}}>
                            <span>{textResources["download"]}</span>
                        </StyledDownloadButton>
                    </a>
                    <div className="other-download-mas">
                        <span>{isIos ? textResources["download_mas_ios_pre"] : textResources["download_mas_pre"]}</span>
                        <a href={textResources["download_mas_link"]}
                           style={{color: color}}
                           target="_blank"
                           rel="noopener noreferrer"
                           onClick={() => window._paq.push(['trackEvent', 'Download', 'App', textResources["download_mas_tracking_name"]])}
                        >
                            <span>{isIos ? textResources["download_mas_ios_link_text"] : textResources["download_mas_link_text"]}</span>
                        </a>
                        <span>{isIos ? textResources["download_mas_ios_post"] : textResources["download_mas_post"]}</span>
                    </div>
                    <div className={isIos ? "other-hidden" : "other-download-ios"}>
                        <span>{textResources["download_ios_pre"]}</span>
                        <a href={textResources["download_ios_link"]}
                           style={{color: color}}
                           target="_blank"
                           rel="noopener noreferrer"
                           onClick={() => window._paq.push(['trackEvent', 'Download', 'App', textResources["download_ios_tracking_name"]])}
                        >
                            <span>{textResources["download_ios_link_text"]}</span>
                        </a>
                        <span>{textResources["download_ios_post"]}</span>
                    </div>
                </div>
            </StyledBox>
        );
    }
}

const StyledBox = styled('div')`
    text-align: center;
/*
    .button-container {
        width: 100%;
        margin: 0 auto;
        
        @media (min-width: ${theme.breakpoints.tablet}px) {
	        width: 80%;
        }
    
        @media (min-width: ${theme.breakpoints.desktop}px) {
	        width: 62%;
	    }
    }
*/
    .other-hidden {
        display: none;
    }
        
    .other-download-mas, .other-download-ios {
        width: 100%;
        display:inline-block;
        padding-top: 0px;
        font-size: ${modularScale(-0.5)};
        
        a {
            color: #4465F9;        
        }
    }
    
    .other-download-mas {
        padding-top: 20px;
    }
`;

const StyledDownloadButton = styled('div')`
	box-sizing: border-box;
	padding-top: 25px;
    padding-right: 40px;
    padding-bottom: 25px;
    padding-left: 40px;
	display: inline-flex;
	align-items: center;
	background-color: #4465F9;
	border-radius: 26px;
	color: ${theme.colors.white};
    height: 40px;
    width: 100%;
    text-align: center;

	> span {
		width: 100%;
		white-space: nowrap;
		font-size: ${modularScale(-0.5)};
		font-weight: 600;
		letter-spacing: 0.01em;
		
		@media (min-width: ${theme.breakpoints.tablet}px) {
	        font-size: ${modularScale(0.2)};
        }
	}
`;